import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { queryClient, QueryKey } from '@/config/query-client';
import { notify } from '@/ui/snackbar/notify';

import { deleteCompanyContact } from '@/api/v4/organization-contacts.api';
import { companyIdState } from '../company.state';
import { useCompanyFetchMode } from '../company-fetch-context';
import { useAtomValue } from 'jotai';

export const useDeleteCompanyContact = () => {
  const { t } = useTranslation('default');
  const companyId = useAtomValue(companyIdState);
  const fetchMode = useCompanyFetchMode();

  const mutation = useMutation({
    mutationFn: deleteCompanyContact,
    onError: () => {
      notify({
        message: t`unknownError`,
      });
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QueryKey.Company, fetchMode, companyId],
        }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.LastActivities] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.LastActivitiesCount],
        }),
      ]);
    },
  });

  return {
    deleteContact: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
};
